/* © ИП Коробкин И.Н., KIN DIGITAL CRM+ */
import { useMutation } from '@tanstack/react-query';
import { FormEvent, useState } from 'react';
import { api } from '@/lib/api';
import { isoToLocal, localToIso } from '@/lib/format';
import { useDirectory } from '@/lib/hooks';
import { Button, ErrorText, Field, Input, Select, Textarea } from './ui';

export function TaskForm({ task, defaults, onSaved }: { task?: any; defaults?: Record<string, string | undefined>; onSaved: () => void }) {
  const { data: people } = useDirectory();
  const [f, setF] = useState({
    title: task?.title ?? '', description: task?.description ?? '', dueAt: isoToLocal(task?.dueAt), assigneeId: task?.assigneeId ?? '',
    priority: String(task?.priority ?? 2), recurrence: task?.recurrence ?? '', checklist: (task?.checklist ?? []).map((c: any) => c.text).join('\n'),
  });
  const save = useMutation({
    mutationFn: () => {
      const prev: { text: string; done: boolean }[] = task?.checklist ?? [];
      const checklist = f.checklist.split('\n').map((s: string) => s.trim()).filter(Boolean).map((text: string) => ({ text, done: prev.find((p) => p.text === text)?.done ?? false }));
      const body = {
        ...defaults, title: f.title, description: f.description || null, dueAt: localToIso(f.dueAt), assigneeId: f.assigneeId || null,
        priority: Number(f.priority), recurrence: f.recurrence || null, checklist: checklist.length ? checklist : null,
      };
      return task ? api.patch(`/tasks/${task.id}`, body) : api.post('/tasks', body);
    },
    onSuccess: onSaved,
  });
  const submit = (e: FormEvent) => { e.preventDefault(); save.mutate(); };
  return (
    <form onSubmit={submit} className="space-y-3">
      <Field label="Задача"><Input required autoFocus value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} /></Field>
      <Field label="Описание"><Textarea value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} /></Field>
      <div className="grid gap-3 sm:grid-cols-2">
        <Field label="Срок"><Input type="datetime-local" value={f.dueAt} onChange={(e) => setF({ ...f, dueAt: e.target.value })} /></Field>
        <Field label="Исполнитель"><Select value={f.assigneeId} onChange={(e) => setF({ ...f, assigneeId: e.target.value })} placeholder="Я"
          options={(people ?? []).map((p) => ({ value: p.id, label: p.fullName }))} /></Field>
        <Field label="Приоритет"><Select value={f.priority} onChange={(e) => setF({ ...f, priority: e.target.value })} options={[{ value: '1', label: 'Низкий' }, { value: '2', label: 'Обычный' }, { value: '3', label: 'Высокий' }]} /></Field>
        <Field label="Повторять"><Select value={f.recurrence} onChange={(e) => setF({ ...f, recurrence: e.target.value })} placeholder="Не повторять"
          options={[{ value: 'DAILY', label: 'Каждый день' }, { value: 'WEEKLY', label: 'Каждую неделю' }, { value: 'MONTHLY', label: 'Каждый месяц' }]} /></Field>
      </div>
      <Field label="Чек-лист" hint="Каждый пункт с новой строки"><Textarea rows={4} value={f.checklist} onChange={(e) => setF({ ...f, checklist: e.target.value })} /></Field>
      <ErrorText error={save.error} />
      <div className="flex justify-end"><Button type="submit" disabled={save.isPending}>Сохранить</Button></div>
    </form>
  );
}
